import { CommonModule } from '@angular/common';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';
import { Component, OnInit } from '@angular/core';
import {
  AbstractControl,
  FormBuilder,
  FormGroup,
  ReactiveFormsModule,
  ValidationErrors,
  Validators,
} from '@angular/forms';

function futureDateValidator(
  control: AbstractControl,
): ValidationErrors | null {
  if (!control.value) return null;
  const date = new Date(control.value);
  const today = new Date();
  today.setHours(0, 0, 0, 0);
  date.setHours(0, 0, 0, 0);
  return date > today ? { futureDob: true } : null;
}
import { ActivatedRoute, Router } from '@angular/router';
import { InputComponent } from '../../shared/components/from-input/input.component';
import { ApiError, HttpService } from '../../shared/services/http.service';
import { requiredTrimmed } from '../../shared/utils/utils';
import { CustomToastComponent } from '../../shared/components/toast/custom-toast.component';
import { MatSnackBar } from '@angular/material/snack-bar';
import { UserRole } from '../../shared/models/user-role.enum';
import { AuthService } from '../services/auth.service';

@Component({
  selector: 'app-unauthor-login',
  templateUrl: './unauthor-login.component.html',
  styleUrls: ['./unauthor-login.component.scss'],
  standalone: true,
  imports: [
    ReactiveFormsModule,
    CommonModule,
    InputComponent,
    MatProgressSpinnerModule,
  ],
})
export class UnauthorLoginComponent implements OnInit {
  form!: FormGroup;
  eventData: any;
  loading: boolean = false;
  isLoading: boolean = false;
  addStudent: boolean = false;
  studentAdded: boolean = false;
  hideClosebtn: boolean = false;
  showConstructionCourseAnswers: boolean = false;
  showConstructionRelatedCourseAnswers: boolean = false;
  depcrtionToken: string = '';
  segmentFromLink: string = '';
  eventIdFromLink: string = '';
  customErrorMessages = {
    firstName: { required: 'Please enter a first name.' },
    lastName: { required: 'Please enter a last name.' },
    personalEmail: {
      required: 'Please enter a personal email address.',
      email: 'Please enter a valid email address.',
      pattern: 'Please enter a valid email address.',
    },
    schoolEmail: {
      required: 'Please enter a school email address.',
      email: 'Please enter a valid school email address.',
      pattern: 'Please enter a valid school email address.',
    },
    parentEmail: {
      required: 'Please enter a parent/guardian email address.',
      email: 'Please enter a valid parent/guardian email address.',
      pattern: 'Please enter a valid parent/guardian email address.',
    },
    parentName: {
      required: 'Please enter a parent or guardian full name.',
    },
    dob: {
      required: 'Please enter a date of birth.',
      futureDob: 'Date of birth cannot be a future date.',
    },
    schoolName: { required: 'Please select a school.' },
    gender: { required: 'Please select a gender.' },
    ethnicity: { required: 'Please select an ethnicity.' },
    studentName: { required: 'Please select a student.' },
    constructionCourse: { required: 'Please select Yes or No for question 1.' },
    constructionRelatedCourse: {
      required: 'Please select Yes or No for question 2.',
    },
    yearLevel: {
      required: 'Please select a year level.',
      pattern: 'Please enter a year level in numeric.',
      min: 'Please enter a year level must be at least 1',
      max: 'Please enter a year level must be 12 or less',
    },
  } as const;
  showPastAnswersError: boolean = false;
  showCompAnswersError: boolean = false;
  duplicateEmailError: string | null = null;

  genderOption: any[] = [
    { label: 'Male', value: 'male' },
    { label: 'Female', value: 'female' },
    { label: 'Non-identifying', value: 'non-identifying' },
    { label: 'Prefer not to say', value: 'prefernottosay' },
  ];

  dataOption: any[] = [
    { label: 'Yes', value: 'yes' },
    { label: 'No', value: 'no' },
  ];
  yearLevelOption: any[] = [];

  ethnicitiesOption: any[] = [];
  userRole: any;
  constructionPastAnswers: any[] = [];
  constructionCompAnswers: any[] = [];

  constructor(
    private router: Router,
    private fb: FormBuilder,
    private route: ActivatedRoute,
    private httpService: HttpService,
    private snackBar: MatSnackBar,
    private authService: AuthService,
  ) {}

  ngOnInit(): void {
    this.initializeForm();
    const renderbtn = localStorage.getItem('hideClosebtn');
    if (renderbtn) {
      this.hideClosebtn = true;
    }
    this.route.queryParams.subscribe((params) => {
      this.depcrtionToken = params['token'];
      this.addStudent = params['register'] === 'true';
      this.studentAdded = params['studentAdded'] === 'true';
      this.segmentFromLink = params['segment'] || 'admin';
      this.eventIdFromLink = params['eventId'] || '';
      // Clear duplicate error whenever params change (covers component reuse in same browser tab)
      this.duplicateEmailError = null;
    });
    console.log(this.segmentFromLink)
    if (this.depcrtionToken) {
      this.getEventDetails();
      this.getYearLevelDetails();
      this.getEthnicityDetails();
      this.getCoursePastDetails();
      this.getCourseCompDetails();
    }

    this.form.get('constructionCourse')?.valueChanges.subscribe((val) => {
      this.showConstructionCourseAnswers = val === 'yes';
    });

    this.form
      .get('constructionRelatedCourse')
      ?.valueChanges.subscribe((val) => {
        this.showConstructionRelatedCourseAnswers = val === 'yes';
      });
  }

  initializeForm(): void {
    this.form = this.fb.group({
      firstName: ['', [requiredTrimmed]],
      lastName: ['', [requiredTrimmed]],
      schoolEmail: ['', [requiredTrimmed, Validators.pattern(/^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/)]],
      dob: ['', [Validators.required, futureDateValidator]],
      parentName: ['', [requiredTrimmed]],
      parentEmail: ['', [requiredTrimmed, Validators.pattern(/^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/)]],
      personalEmail: ['', [Validators.pattern(/^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/)]],
      gender: ['', [Validators.required]],
      ethnicity: ['', [Validators.required]],
      yearLevel: [''],
      constructionCourse: ['', [Validators.required]],
      constructionRelatedCourse: ['', [Validators.required]],
      focusArea: [[]],
      focusArea2: [[]],
    });
  }
  getEventDetails(): void {
    this.httpService
      .get<any>(
        `anonymous/students/gen-link/decrypt?token=${this.depcrtionToken}`,
      )
      .subscribe({
        next: (response) => {
          if (response?.status) {
            this.eventData = response?.data;
            localStorage.setItem(
              'studentEvent',
              JSON.stringify(this.eventData),
            );
          }
        },
        error: (err) => {
          console.error('Failed to load Event Types:', err);
          this.showErrorToast(err?.message);
        },
        complete: () => {
          this.loading = false;
        },
      });
  }
  getYearLevelDetails(): void {
    this.httpService
      .get<any>(`anonymous/yearlevel?token=${this.depcrtionToken}`)
      .subscribe({
        next: (response) => {
          if (response?.data) {
            this.yearLevelOption = response.data.map(
              (item: { year_level_name: string; yearlevelid: string }) => ({
                label: item.year_level_name,
                value: item.yearlevelid,
              }),
            );
          }
        },
        error: (err) => {
          console.error('Failed to load Event Types:', err);
          this.showErrorToast(err?.message);
        },
        complete: () => {
          this.loading = false;
        },
      });
  }

  getEthnicityDetails(): void {
    this.httpService
      .get<any>(`anonymous/ethnicities?token=${this.depcrtionToken}`)
      .subscribe({
        next: (response) => {
          if (response?.data) {
            this.ethnicitiesOption = response.data.map(
              (item: { ethnicity_name: string; ethnicities_id: string }) => ({
                label: item.ethnicity_name,
                value: item.ethnicities_id,
              }),
            );
          }
        },
        error: (err) => {
          console.error('Failed to load Event Types:', err);
          this.showErrorToast(err?.message);
        },
        complete: () => {
          this.loading = false;
        },
      });
  }

  getCoursePastDetails(): void {
    this.httpService
      .get<any>(`anonymous/con-rel-course-past?token=${this.depcrtionToken}`)
      .subscribe({
        next: (response) => {
          if (response?.data) {
            this.constructionPastAnswers = response.data.map(
              (item: { courseName: string; id: string }) => ({
                label: item.courseName,
                value: item.id,
              }),
            );
          }
        },
        error: (err) => {
          console.error('Failed to load Event Types:', err);
          this.showErrorToast(err?.message);
        },
        complete: () => {
          this.loading = false;
        },
      });
  }

  getCourseCompDetails(): void {
    this.httpService
      .get<any>(`anonymous/con-rel-course-comp?token=${this.depcrtionToken}`)
      .subscribe({
        next: (response) => {
          if (response?.data) {
            this.constructionCompAnswers = response.data.map(
              (item: { courseName: string; id: string }) => ({
                label: item.courseName,
                value: item.id,
              }),
            );
          }
        },
        error: (err) => {
          console.error('Failed to load Event Types:', err);
          this.showErrorToast(err?.message);
        },
        complete: () => {
          this.loading = false;
        },
      });
  }

  onSave(): void {
    this.duplicateEmailError = null;
    this.form.markAllAsTouched();
    if (this.showConstructionCourseAnswers) {
      this.showPastAnswersError =
        (this.form.value.focusArea?.length ?? 0) === 0;
    }
    if (this.showConstructionRelatedCourseAnswers) {
      this.showCompAnswersError =
        (this.form.value.focusArea2?.length ?? 0) === 0;
    }

    if (
      !this.form.valid ||
      this.showPastAnswersError ||
      this.showCompAnswersError
    )
      return;
    if (!this.form.valid) return;

    this.isLoading = true;

    const formValue = this.form.value;
    const pastCourses = this.constructionPastAnswers.map((course) => ({
      courseId: course.value,
      courseName: course.label,
      value: formValue.focusArea?.includes(course.value) ?? false,
    }));

    const compCourses = this.constructionCompAnswers.map((course) => ({
      courseId: course.value,
      courseName: course.label,
      value: formValue.focusArea2?.includes(course.value) ?? false,
    }));
    const payload = {
      schoolId: this.eventData?.schoolIds[0],
      firstName: formValue.firstName,
      lastName: formValue.lastName,
      dateOfBirth: formValue.dob,
      schoolEmail: formValue.schoolEmail,
      personalEmail: formValue.personalEmail || null,
      yearLevelId: formValue.yearLevel || null,
      parentGuardianFullName: formValue.parentName,
      parentGuardianEmail: formValue.parentEmail,
      gender: formValue.gender || null,
      ethnicityId: formValue.ethnicity || null,
      past: pastCourses,
      comp: compCourses,
    };

    this.httpService
      .post<any>(`anonymous/create?token=${this.depcrtionToken}`, payload)
      .subscribe({
        next: (response: any) => {
          this.isLoading = false;
          if (response?.status) {
            this.studentAdded = true;
            this.router.navigate([], {
              queryParams: { studentAdded: 'true', register: null },
              queryParamsHandling: 'merge',
            });
          }
        },
        error: (error: ApiError) => {
          this.isLoading = false;
          const msg = (error.message || '').toLowerCase();
          const isDuplicate =
            error.status === 409 ||
            msg.includes('already exists') ||
            msg.includes('already have an account');
          if (isDuplicate) {
            this.duplicateEmailError =
              'You already have an account, please log in or reset your password.';
          } else if (error.errors && typeof error.errors === 'object') {
            const messages = Object.values(error.errors).flat().join(' ');
            this.showErrorToast(messages || error.message);
          } else {
            this.showErrorToast(error.message);
          }
        },
      });
  }

  goBackEvent(): void {
    this.studentAdded = false;
    this.addStudent = false;
    this.form.reset();
    this.router.navigate([], {
      queryParams: {},
      queryParamsHandling: '',
      replaceUrl: true,
    });
  }

  onCancel(): void {
    if (this.duplicateEmailError) {
      this.router.navigate(['/auth/login']);
      return;
    }
    this.router.navigate([], {
      queryParams: { register: null, studentAdded: null },
      queryParamsHandling: 'merge',
    });
    this.addStudent = false;
    this.form.reset();
  }

  goToResetPassword(): void {
    this.router.navigate(['/auth/forgot-password']);
  }

  goToLogin(): void {
    this.isLoading = true;

    if (this.authService.isAuthenticated()) {
      // Any authenticated user — navigate directly to the event with the correct segment from the link
      const eventId = this.eventIdFromLink || this.eventData?.eventId;
      const segment = this.segmentFromLink;

      if (this.eventData) {
        localStorage.setItem('studentEvent', JSON.stringify(this.eventData));
      }

      this.router.navigate(['/events/event-list/view', eventId], {
        queryParams: { segment },
      });
      this.isLoading = false;
      return;
    }

    // Not logged in — save event data and segment, then redirect to login
    if (this.eventData) {
      localStorage.setItem('studentEvent', JSON.stringify(this.eventData));
    }
    localStorage.setItem('studentEventSegment', this.segmentFromLink);

    setTimeout(() => {
      this.router.navigate(['/auth/login']);
      this.isLoading = false;
    }, 3000);
  }

  get eventImage(): string {
    return (
      this.eventData?.eventTypeImage ||
      '../../../assets/images/placeholder-image.svg'
    );
  }
  
  closeTab(): void {
    const renderbtn = localStorage.getItem('hideClosebtn');
    if (renderbtn === null) {
      this.hideClosebtn = true;
      localStorage.setItem('hideClosebtn', 'true');
    }
  }

  addStudentFunction(): void {
    this.router.navigate([], {
      queryParams: { register: 'true' },
      queryParamsHandling: 'merge',
    });
  }

  onFocusAreaChange(event: any, question: 1 | 2): void {
    const value = event.target.value;
    const checked = event.target.checked;
    const controlName = question === 1 ? 'focusArea' : 'focusArea2';
    const current: string[] = this.form.get(controlName)?.value ?? [];

    const updated = checked
      ? [...current, value]
      : current.filter((v) => v !== value);

    this.form.get(controlName)?.setValue(updated);
  }

  private showSuccessToast(message: string): void {
    this.snackBar.openFromComponent(CustomToastComponent, {
      data: { message },
      duration: 3000,
      horizontalPosition: 'right',
      verticalPosition: 'top',
      panelClass: ['no-padding-snackbar', 'success-toast'],
    });
  }

  private showErrorToast(message: string | null | undefined): void {
    if (!message) return;
    this.snackBar.openFromComponent(CustomToastComponent, {
      data: { message },
      duration: 3000,
      horizontalPosition: 'right',
      verticalPosition: 'top',
      panelClass: ['no-padding-snackbar', 'error-toast'],
    });
  }
}
